<template>
  <div class="compositions-editor">
    <Toolbar />

    <div class="editor-content">
      <div class="editor-sidebar">
        <Sidebar />
      </div>
      
      <div class="editor-main">
        <CompositionPreviewArea />
      </div>

      <div class="editor-properties" :class="{'hidden': !getCurrentCompositionElement}">
        <PropertiesPanel />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import * as namespaceStore from "../vuexStore/namespaceStore.js"
import * as actions from "../vuexStore/actions.js"
import * as mutates from "../vuexStore/mutations.js"
import Toolbar from '../components/Toolbar.vue'
import CompositionPreviewArea from '../components/compositions/PreviewArea.vue'
import Sidebar from '../components/compositions/Sidebar.vue'
import PropertiesPanel from '../components/compositions/PropertiesPanel.vue'

export default {
  name: 'Compositions',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.compositions.length == 0) {
        vm.createDefaultComposition();
      }
      if (to.params.siteId && vm.compositionBySiteID(to.params.siteId)) {
        vm.setCompositionEditing(vm.compositionBySiteID(to.params.siteId));
      } else {
        vm.createCompositionAndSetEditing();
      }
    })
  },
  components: {
    CompositionPreviewArea,
    Sidebar,
    PropertiesPanel,
    Toolbar
  },
  computed: {
    ...mapGetters(namespaceStore.THEME, [
      'compositionBySiteID',
      'compositions',
      'compositionEditing',
      'getCurrentCompositionElement'
    ]),
  },
  methods: {
    ...mapMutations(namespaceStore.THEME, {
      setCompositionEditing: mutates.SET_COMPOSITION_EDITING,
      createDefaultComposition: mutates.CREATE_DEFAULT_COMPOSITION
    }),
    ...mapActions(namespaceStore.THEME, {
      createCompositionAndSetEditing: actions.CREATE_COMPOSITION_AND_SET_EDITING,
    }),
  }
}
</script>

<style scoped>
.editor-properties.hidden {
  transform: translateX(100%);
}

.compositions-editor {
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #111827;
  color: #e5e7eb;
  width: 100%;
  height: 100%;
}

.editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #1f2937;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.editor-header h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #e5e7eb;
}

.header-actions {
  display: flex;
  gap: 1rem;
}

.action-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: rgba(59, 130, 246, 0.2);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 0.375rem;
  color: #3b82f6;
  font-weight: 500;
  transition: all 0.2s ease;
}

.action-button:hover {
  background-color: rgba(59, 130, 246, 0.3);
  border-color: #3b82f6;
}

.action-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.4);
}

.action-icon {
  width: 1.25rem;
  height: 1.25rem;
}

.editor-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.editor-sidebar {
  width: 300px;
  overflow-y: auto;
  border: 1px solid #a4a4a4;
  border-radius: 5px 5px 5px 5px;
  background: rgb(31, 41, 55);
}

.editor-main {
  flex: 1;
  overflow: hidden;
  position: relative;
}

.editor-properties {
  width: 300px;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  overflow-y: auto;
  display: flex;
  transition: all 0.3s ease;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid #a4a4a4;
  border-radius: 5px 5px 5px 5px;
}

</style> 